<template>
  <v-container>
    <v-row>
      <div class="display-1 mb-3">Papers</div>
    </v-row>
    <v-layout>
      <v-container>
        <v-row wrapped>
          <v-card
            v-for="(paper, index) in papers"
            :key="paper.id"
            max-width="400"
            min-width="250"
            height="270"
            class="mr-4 mb-4"
            @mouseover="paper.hover = true"
            @mouseleave="paper.hover = false"
          >
            <v-card-title>
              <v-icon left>mdi-script-outline</v-icon>
              <span class="title font-weight-light">{{paper.name}}</span>
            </v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
              <v-icon left>mdi-currency-usd</v-icon>
              <span>{{paper.m2cost}} /m2</span>
            </v-card-text>
            <v-card-text v-if="paper.width">
              <v-icon left>mdi-arrow-left-right</v-icon>
              <span>{{paper.width}} mm</span>
            </v-card-text>
            <v-card-text v-if="paper.width">
              <v-icon left>mdi-arrow-up-down</v-icon>
              <span>{{paper.length}} mm</span>
            </v-card-text>
            <v-row align="center" justify="end">
              <v-card-action class="mr-4 mb-1">
                <v-btn icon v-if="paper.hover">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-card-action>
            </v-row>
          </v-card>
        </v-row>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  created() {
    this.papers.forEach(paper => {
      // since the objects above do not have hover on them already.
      // if you can pre set them in the objects above in code you wont need to do this.
      this.$set(paper, 'hover', false);
    });
  },
  computed: {
    papers() {
      return this.$store.getters.getPapers;
    }
  }
};
</script>

<style scoped>
</style>